import { createSelector } from 'reselect';

export const getTenants = ({ tenants }) => tenants;

export const getCompanyKeys = createSelector(getTenants, (tenants) =>
	tenants.map(({ CompanyKey }) => CompanyKey),
);
